import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);


const colors = ['#f9adaa', '#a4b6da', '#28a745', '#FFC107']; // Extend if more years

const DynamicBarChart = ({ section, data, height }) => {
  // //console.log('ni', section, data)
  const sectionData = data;
  const fiscalYears = Object.keys(sectionData); 
  const categories = Object.keys(sectionData[fiscalYears[0]]); // e.g. ['H1', 'H2']

  const chartData = {
    labels: categories,
    datasets: fiscalYears.map((fy, index) => ({
      label: fy,
      data: categories.map((cat) => Number(sectionData[fy][cat])),
      backgroundColor: colors[index % colors.length],
    })),
  };

  const options = {
    responsive: true,
          maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top' },
      title: {
        text: section,
        display: true,
      },
      datalabels: {
        display: false,
        color: "white",
        font: {
          weight: "bold",
        }
      },
    },
    scales: {
      y: { beginAtZero: true },
    },
  };

  return (
    <Bar style={{ backgroundColor: "white", borderRadius: "7px" }} data={chartData} options={options} height={height}/>
  );
};

export default DynamicBarChart;
